import React, { useState } from "react";
import { Grid, IconButton, Tooltip, Typography, Divider } from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

const BankActionMenu = ({ isEdit, onSave, onDelete, onExit, saveDisabled }) => {
  const [selectedButton, setSelectedButton] = useState(null);

  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName);

    switch (buttonName) {
      case "save":
        onSave();
        break;
      case "delete":
        onDelete();
        break;
      case "exit":
        onExit();
        break;
      default:
        break;
    }
  };

  return (
    <Grid container justifyContent="space-between" alignItems="center" padding={1}>
      {/* Title */}
      <Grid item>
        <Typography variant="h4" sx={{ ml: 2 }}>
          {isEdit ? "Edit Bank" : "New Bank"}
        </Typography>
      </Grid>

      {/* Buttons */}
      <Grid item>
        <Grid container alignItems="center">
          {/* Save */}
          <Grid item>
            <Tooltip title="Save Bank">
              <IconButton
                onClick={() => handleButtonClick("save")}
                disabled={saveDisabled}
              >
                <SaveAltIcon
                  style={{ color: selectedButton === "save" ? "yellow" : "#009688" }}
                />
                <Typography variant="body2" sx={{ ml: 0.5 }}>
                  Save
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Delete (only in edit mode) */}
          {isEdit && (
            <>
              <Grid item>
                <Tooltip title="Delete Bank">
                  <IconButton onClick={() => handleButtonClick("delete")}>
                    <DeleteIcon
                      style={{ color: selectedButton === "delete" ? "red" : "#f44336" }}
                    />
                    <Typography variant="body2" sx={{ ml: 0.5 }}>
                      Delete
                    </Typography>
                  </IconButton>
                </Tooltip>
              </Grid>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            </>
          )}

          {/* Exit */}
          <Grid item>
            <Tooltip title="Exit">
              <IconButton onClick={() => handleButtonClick("exit")}>
                <CloseIcon style={{ color: "#2196F3" }} />
                <Typography variant="body2" sx={{ ml: 0.5 }}>
                  Exit
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BankActionMenu;
